import React from 'react';
import Box from '@mui/material/Box';
import { BarLoader } from 'react-spinners';
import { useTheme } from '@mui/material/styles';

interface LoaderProps {
  loading: boolean;
}

const Loader: React.FC<LoaderProps> = ({ loading }) => {
  const theme = useTheme();

  if (!loading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 9999,
      }}
    >
      <BarLoader color={theme.palette.primary.main} loading={loading} width="100%" height={4} />
    </Box>
  );
};

export default Loader;
